module.exports = __webpack_public_path__ + "static/img/lrs_lieren_img@2x.2fe8411.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lrsimages/rules/lrs_lieren_img@2x.png
// module id = P7v7
// module chunks = 23